var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register" }, [
    _c(
      "body",
      {
        staticClass: "account-page",
        staticStyle: {
          "font-family": "'CircularStd', sans-serif",
          "font-size": ".9375rem",
          color: "#1f1f1f",
          "background-color": "#f7f7f7",
          "min-height": "100%",
          "overflow-x": "hidden"
        }
      },
      [
        _c("div", { staticClass: "main-wrapper" }, [
          _c("div", { staticClass: "account-content" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "account-logo" },
                [
                  _c("router-link", { attrs: { to: "/index" } }, [
                    _c("img", {
                      attrs: { src: _vm.logoText, alt: _vm.appTitle }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "account-box" }, [
                _c("div", { staticClass: "account-wrapper" }, [
                  _c("h3", { staticClass: "account-title" }, [
                    _vm._v("Register")
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "was-validated",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.createValidation($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Email")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.member_email,
                              expression: "fields.member_email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "email", required: "" },
                          domProps: { value: _vm.fields.member_email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fields,
                                "member_email",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Phone")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.member_mobilephone,
                              expression: "fields.member_mobilephone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.fields.member_mobilephone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fields,
                                "member_mobilephone",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Name")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.member_name,
                              expression: "fields.member_name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.fields.member_name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fields,
                                "member_name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Password")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.member_password,
                              expression: "fields.member_password"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "password", required: "" },
                          domProps: { value: _vm.fields.member_password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fields,
                                "member_password",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Repeat Password")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.member_repeat_password,
                              expression: "fields.member_repeat_password"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "password", required: "" },
                          domProps: {
                            value: _vm.fields.member_repeat_password
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fields,
                                "member_repeat_password",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.toggleCouponCode }
                          },
                          [_vm._v("Enter Referral Code")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.showCouponCode
                        ? _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Referral")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.fields.referral_code,
                                  expression: "fields.referral_code"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.fields.referral_code },
                              on: {
                                change: _vm.detailReferral,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.fields,
                                    "referral_code",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.referralInfo.member_name != ""
                              ? _c("span", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "Referral Name: " +
                                      _vm._s(_vm.referralInfo.member_name)
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary account-btn",
                            attrs: {
                              disabled: _vm.isDisabled == 1,
                              type: "submit"
                            }
                          },
                          [_vm._v("Register")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "account-footer" }, [
                        _c(
                          "p",
                          [
                            _vm._v(
                              "\n                    Already have an account?\n                    "
                            ),
                            _c("router-link", { attrs: { to: "/login" } }, [
                              _vm._v("Login")
                            ])
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "custom-control custom-checkbox mb-3" }, [
        _c("input", {
          staticClass: "custom-control-input",
          attrs: {
            type: "checkbox",
            id: "customControlValidation1",
            required: ""
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "custom-control-label",
            attrs: { for: "customControlValidation1" }
          },
          [_vm._v("I accept Terms of Service and Privacy Policy.")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-022fc800", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-022fc800","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/register/index.vue
// module id = null
// module chunks = 